//declare var sweetAlert: any;

//export class MessageBox {

//    static Message(message: string, title?:string) {

//        if (title)
//            sweetAlert({
//                title: message,
//                text: title
//            });
//        else {
//            sweetAlert(message);
//        }
                
//    }

//    static Success(message:string, title:string) {

//        sweetAlert({
//                title: title,
//                text: message,
//                type: "success",
//                confirmButtonClass: "btn-success",
//                confirmButtonText: "Success"
//            }); 
//    }

//    static Confirm(message: string, title:string, callback: Function) {
//        sweetAlert({
//                title: title,
//                text: message,
//                type: "warning",
//                showCancelButton: true,
//                cancelButtonClass: "btn-default",
//                confirmButtonClass: "btn-warning",
//                confirmButtonText: "Confirm",
//                closeOnConfirm: true
//            },
//            callback
//        );
//    }

//}